import * as yup from 'yup';
export const paymentInitialValues: any = {
  price: '',
  description: '',
  items: [{ name: '', description: '', price: 0 }],
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  dueDate: new Date(),
};

export const PaymentSchemaYup = yup.object().shape({
  price: yup.number().required('Price is required'),
  description: yup.string().optional(),
  items: yup.array().of(
    yup.object().shape({
      name: yup.string().required('Name is required'),
      description: yup.string().optional(),
      price: yup.number().required('Price is required'),
    })
  ),
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  phone: yup.string().required('Phone is required'),
  dueDate: yup.date().required('Due date is required'),
  analystName: yup.string().optional(),
});
